
import { Box, styled } from '@mui/joy';

export const HBox = styled(Box, {
  slot: 'root',
  name: 'HBox'
})(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 1
}))

export default HBox;